import Logo from 'assets/images/logo.svg';
import LogoM from 'assets/images/logo-m1.svg';
import Person from 'assets/images/svg/icon_person.svg';
import Login from 'assets/images/svg/icon_in.svg';
import { Link } from 'react-router-dom';
import { useAuthState, useAuthDispatch, logout } from 'context';
import Avatar from 'assets/images/svg/avatar.svg';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'components/utils';

export const Header = () => {
	const { userDetails } = useAuthState();
	const history = useHistory();
	const dispatch = useAuthDispatch();

	const handleLogout = () => {
		logout(dispatch);
		history.push('/login');
	};

	return (
		<header id='header'>
			<div className='container'>
				<Link className='logo_link3' to={'/'}>
					<picture>
						<source srcSet={LogoM} media='(max-width: 768px)' />
						<img src={Logo} alt={'logo'} />
					</picture>
				</Link>
				{history.location.pathname !== '/' && !isMobile && (
					<p className='header_text'>
						<span>Долголетие для всех</span>
						<br />
						<span>
							ВСЕРОССИЙСКИЙ КОНКУРС ЛУЧШИХ ПРАКТИК <br />
							РАБОТЫ С ЛЮДЬМИ СТАРШЕГО ПОКОЛЕНИЯ
						</span>
					</p>
				)}
			{!isMobile && <Link style={{margin:'0 auto', color:'white', fontSize:'26px', textDecoration: 'none'}} className='logo_link3' to={'/voting'}>
				Народное голосование
				</Link>}	
				{userDetails.name ? (
					<div className='details'>
						<Link className='' to={'/profile'}>
							<div>
								<img src={Avatar} alt='ava' />
							</div>
							<div className='details_text'>
								<span>{userDetails.surname}</span>
								<br></br>
								<span>
									{userDetails.name} {userDetails.patronymic}
								</span>
							</div>
						</Link>
						<img
							className='main__icon-in'
							onClick={handleLogout}
							src={Login}
							alt='person'
						/>
					</div>
				) : (
					<Link className='main__btn-in main__btn-in_second' to={'/login'}>
						<img className='main__icon-person' src={Person} alt='person' />
						Вход / Регистрация
						<img className='main__icon-in' src={Login} alt='person' />
					</Link>
				)}
			</div>
		</header>
	);
};
